export const iconFontAwesomePoliticalDemocrat = (
	<i className="fa-solid fa-democrat"></i>
);
